module.exports = __webpack_public_path__ + "img/loader.6068d1f9.gif";